module.exports = __webpack_public_path__ + "static/media/left-arrow.e2f47880.svg";